import { IEditMeetingOrderData } from "../../../../Types/MeetingPlanning/deliveryForm"

export const editOrderData = (order: IEditMeetingOrderData | null) => order
